module.exports = __webpack_public_path__ + "static/media/volauvent.0108809d.jpg";